import { ref } from 'vue'

/**
 *
 * @param {*} fn 加载数据的方法
 * @returns
 */
export const useBaseMixins = (fn) => {
	const formLoading = ref(false) //修改时表单加载数据
	const saving = ref(false) //保存时
	const formVisible = ref(false) //显示编辑
	const formTitle = ref('新增')
	const form = ref({}) //表单
	const loading = ref(false) //加载数据
	const selectionNodes = ref([])
	const currentId = ref(0)
	const tableRef = ref()
	const isShowTooltip = ref(false)
	const curRow = ref('')
	/** 判断标签内容是否超出标签宽度，超出则显示tooltip */
	const mouseenterChange = (event, intention) => {
		const node = event.target
		const nodeContentWidth = getNodeContentWidth(node)
		const nodeWidth = node.clientWidth
		if (nodeContentWidth >= nodeWidth) {
			// 如果childNodes下的text宽度等于元素宽度 文字溢出
			isShowTooltip.value = true
		} else {
			// 否则为不溢出
			isShowTooltip.value = false
		}

		curRow.value = intention
	}

	const getNodeContentWidth = (node) => {
		// 创建临时元素
		const tempElement = document.createElement('span')
		tempElement.style.visibility = 'hidden' // 确保元素不可见
		tempElement.style.position = 'absolute' // 确保元素脱离文档流
		tempElement.style.whiteSpace = 'nowrap'
		// 将div内容复制到临时元素
		tempElement.textContent = node.textContent

		// 将临时元素添加到传入元素的父元素中
		node.parentNode.appendChild(tempElement)

		// 获取宽度
		const width = tempElement.clientWidth

		// 移除临时元素
		node.parentNode.removeChild(tempElement)

		return width
	}
	const query = ref({
		page: 1,
		limit: 15,
		type: 0,
		types: 'my',
		keywords: '',
		order: {
			sort: '',
			field_name: ''
		}
	}) //查询条件
	//分页表格数据
	const tableData = ref({
		data: [],
		total: 0
	})
	//不分页表格数据列表
	const dataList = ref([])

	//记录加载数据的方法
	let load

	/**
	 * 加载数据
	 * @param {*} fun 传递加载数据的方法
	 * @returns
	 */
	const loadData = (fun) => {
		if (load) {
			load()
		} else if (fun && typeof fun === 'function') {
			load = fun
		}
		return fun
	}

	/**
	 * 搜索数据
	 */
	const onSearch = () => {
		query.value.page = 1
		load()
	}

	/**
	 * 排序
	 */
	const onSort = (e) => {
		if (e.prop) {
			query.value.order = {
				sort: e.order,
				field_name: e.prop
			}
			load()
		}
	}
	/**
	 * 分页页数更改
	 */
	const onSizeChange = (val) => {
		query.value.limit = val
		query.value.page = 1
		load()
	}
	/**
	 * 分页页码更改
	 */
	const onPageChange = (val) => {
		query.value.page = val
		load()
	}

	let _on_success

	/**
	 * 批量选择表 格操作成功
	 */
	const onBatchSuccess = () => {
		if (_on_success) {
			_on_success()
		} else {
			tableRef.value.clearSelection()
			load()
		}
	}

	//如果需要重写 请传入 重写的方法
	if (fn && typeof fn === 'function') {
		let opts = fn()
		if (opts.onBatchSuccess && typeof opts.onBatchSuccess === 'function') {
			_on_success = opts.onSuccess
		}
	}

	//返回
	return {
		formVisible,
		formTitle,
		saving,
		form,
		formLoading,
		loading,
		query,
		selectionNodes,
		currentId,
		tableRef,
		tableData,
		dataList,
		onPageChange,
		onSizeChange,
		onSort,
		onSearch,
		loadData,
		onBatchSuccess,
		isShowTooltip,
		curRow,
		mouseenterChange,
		getNodeContentWidth
	}
}

export default {
	useBaseMixins: useBaseMixins
}
